import { useState, useEffect } from 'react';
import S from './DropdownFilterStyles';

function CheckboxSearchOption({
  option,
  type,
  filters,
  setFilters,
}: any):JSX.Element {
  const [value, label] = Object.entries(option)[0] as [string, string];
  const [checkedState, toggleCheckedState] = useState(filters[type]?.includes(value));

  useEffect(() => {
    toggleCheckedState(filters[type]?.includes(value));
  }, [filters[type]]);

  const handleSearch = (): void => {
    const current = filters[type] ?? [];
    const has = current.includes(value);
    const next = has ? current.filter((val: string) => val !== value) : [...current, value];
    setFilters({ ...filters, [type]: next });
    toggleCheckedState(!has);
  };

  return (
    <S.SearchItemWrapper onClick={() => handleSearch()}>
      <input type="checkbox" id={value} checked={checkedState} disabled />
      <label htmlFor={label}>
        <span className="checkbox" />
        {label}
      </label>
    </S.SearchItemWrapper>
  );
}

export default CheckboxSearchOption;
